import React, { useContext } from 'react'
import { Route, Routes } from 'react-router-dom'

import NotFound from '../NotFound'

import { AbilityContext } from '../../components/Ability'
import StockListPage from './Features/StockList'

const StockPage = () => {
  const ability = useContext(AbilityContext)

  return (
    <Routes>
      <Route
        path="/"
        element={
          ability.can('manage', 'Product', 'reportProduct') ? <StockListPage /> : <NotFound />
        }
      />
    </Routes>
  )
}

export default StockPage
